import GetIcon, { GetFontAwesomeIcon } from "@/components/font-awesome-icon";
import PageHeader from "@/components/page-header";
import UIButton from "@/components/ui-controls/button";
import UIToggleButton from "@/components/ui-controls/toggle-buttons";
import {
  faCalendar,
  faCalendarDays,
  faCircleQuestion,
  faPenToSquare,
  faTrashCan,
} from "@fortawesome/free-regular-svg-icons";
import {
  faList,
  faPlus,
  faTableColumns,
} from "@fortawesome/free-solid-svg-icons";
import Divider from "@mui/material/Divider";
import CalendarSection from "./calendar-section";
import { useSelector, useDispatch } from "react-redux";
import {
  getAppointmentType,
  getAppointments,
  getFilteredAppointments,
  getMembers,
  getSelectedAppointment,
  getSelectedDate,
  getServiceTypes,
  getSwitchType,
  getSwitchView,
  getCalendarView,
  setSelectedAppointmentToState,
  setSelectedDateToState,
  setSwitchViewToState,
  setCalendarView,
  getSavedInfoWhenLeadCreate,
  getPendingAppointmentModal,
} from "@/store/slices/appointment/appointmentSlice";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import AppointmentModal from "@/modules/crm/appointment/components/modals/appointment-modal";
import TableSection from "./table-section";
import AppointmentDeleteModal from "../../modals/delete-modal";
import moment from "moment";
import GridActionPopover from "@/components/page-header/grid-actions-popover";
import UseGql from "@/services/graph-ql/useGql";
import {
  getCurrentTimezone,
  GetDurationForAppointments,
} from "@/services/generic.methods";
import useManageAppointment from "../../modals/appointment-modal/useManageAppointment";
import { useCRMDataClient } from "@/services/data-client/DataClientContext";
import {
  Enums,
  AppointmentPermissionKeys,
  resolveAppointmentSubmodulePermission,
} from "@/services/dropdown-enums";
import ViewAppointment from "@/modules/crm/leads/components/lead-details/right-section/appointment/view-appointment";
import useRoles from "@/hooks/useRoles";
import CircularLoader from "@/components/circular-loader";
import { time } from "@/modules/crm/global/constants";
import { toast } from "react-toastify";
import { getTimezones } from "@/store/slices/general/generalSlice";
import { Get_Slots_By_Date } from "@/modules/crm/leads/graphql-queries/appointment-scheduling";
import VideoPopper from "@/components/video-poper";
import TimeZoneField from "../../modals/appointment-modal/timezone-field";
import { DayEvent, DayEventStyling } from "./column-view/day-view-custom";
import { Views } from "react-big-calendar";
import dayjs from "dayjs";
import trackingService from "@/services/tracking/tracking-service";
import { TRACKING_EVENTS } from "@/services/tracking/tracking-events";

// window.addEventListener('resize', function(event) {
//   showTooltip = window?.innerWidth <= 1256
//   console.log(showTooltip, 'window?.innerWidth');
// }, true);

export const makeRangeQuery = (range = {}, view = "month") => {
  const duration = view === "month" ? "week" : "day";
  const count = 1;

  return {
    where: {
      and: [
        {
          startDate: {
            gte: GetDurationForAppointments(
              -count,
              duration,
              range?.start
            ),
          },
        },
        {
          startDate: {
            lte: GetDurationForAppointments(
              count,
              duration,
              range?.end
            ),
          },
        },
      ],
    },
  };
};

export const initialRange = {
  start: moment().startOf("month"),
  end: moment().endOf("month"),
};

const findAppointmentByEventId = (appointments, eventId) =>
  appointments?.find(
    (appointment) =>
      !appointment?.isBusy &&
      (String(appointment.eventId) === String(eventId) ||
        String(appointment.id) === String(eventId))
  );

const DetailSection = ({
  fetchAppointments = () => {},
  refetching = false,
  openCreateModal = false,
  setColors = () => {},
}) => {
  const permission = useRoles("appointments")?.getPermission;
  const schedulingPermission = resolveAppointmentSubmodulePermission(
    permission,
    AppointmentPermissionKeys.SCHEDULING
  );
  const [openAppModal, setOpenAppModal] = useState(false);
  const [requestType, setRequestType] = useState("");
  const [openViewModal, setOpenViewModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const switchView = useSelector(getSwitchView);
  const appointments = useSelector(getFilteredAppointments);
  const storedAppointments = useSelector(getAppointments);
  const selectedAppointment = useSelector(getSelectedAppointment);
  const dispatch = useDispatch();
  const router = useRouter();
  const returnFrom = router.query?.returnFrom;
  const selectedView = useSelector(getCalendarView);
  const [range, setRange] = useState({ ...initialRange });
  const appointmentType = useSelector(getAppointmentType);
  const getSlotsByDate = UseGql(Get_Slots_By_Date);
  const { client: dataClient } = useCRMDataClient();
  const timezones = useSelector(getTimezones);
  const [columnsData, setColumnsData] = useState([]);
  const serviceTypes = useSelector(getServiceTypes);
  const members = useSelector(getMembers);
  const switchType = useSelector(getSwitchType);
  const calendarDate = useSelector(getSelectedDate);
  const savedInfoWhenLeadCreate = useSelector(getSavedInfoWhenLeadCreate);
  const pendingAppointmentModal = useSelector(getPendingAppointmentModal);
  const lastHandledOpenAtRef = useRef(null);
  const {
    handleAppointmentStatus = async () => {},
    loading,
    isChanging,
  } = useManageAppointment({
    range: range,
    selectedView: selectedView,
    showResponse: false,
    showStatusResponse: true,
    fetchAppointments,
    setColors: setColors,
  });

  const handleViewChange = (value) => {
    dispatch(setSwitchViewToState(value));
  };

  const handleCalendarViewChange = (view) => {
    dispatch(setCalendarView(view));
  };

  const goToSettings = () => {
    if (router.pathname.includes("/crm/appointments/calendars")) {
      router.push("/crm/appointments/appointment-scheduling");
    } else {
      router.push("/crm/settings/integrations/appointment-scheduling");
    }
  };

  const onSaveAppointment = (values) => {
    console.log("appointment saved", values);
    const effectiveView = switchView === "columns" ? "day" : selectedView;
    fetchAppointments(makeRangeQuery(range, effectiveView));
  };

  const onAppointmentDelete = async () => {
    setDeleteLoading(true);
    // dispatch(removeAppointment(selectedAppointment));
    await handleAppointmentStatus(
      selectedAppointment.id,
      Enums.AppointmentStates.Deleted
    );
    onCloseModal();
  };

  const onCloseModal = () => {
    dispatch(setSelectedAppointmentToState(null));
    setOpenAppModal(false);
    setOpenViewModal(false);
    setOpenDeleteModal(false);
    setRequestType("");
    setDeleteLoading(false);
  };

  const onSlotClick = (slot) => {
    const date = moment(slot?.start || slot?.slots?.[0]);
    if (!date.isValid()) return;

    if (switchView === "calendar" && selectedView === "month") {
      dispatch(setSelectedDateToState(date.startOf("day").toISOString()));
      dispatch(setSwitchViewToState("columns"));
      return;
    }

    if (permission.edit) {
      setRequestType("");
      let payload = {
        date,
        title: "",
      };
      if (moment().startOf("day").isSameOrBefore(date)) {
        trackingService.track(TRACKING_EVENTS.ADD_APPOINTMENT);
        dispatch(setSelectedAppointmentToState(payload));
        setOpenAppModal(true);
      } else {
        toast.error("Appointment could not be scheduled for past dates");
      }
    }
  };

  const [checking, setChecking] = useState(false);
  const checkAvailabeSlots = async (appoinment) => {
    let { start: date, calendarId, timeZone } = appoinment;
    const finalTimeZoneId =
      timeZone || appoinment?.selectedTimeZone || form.values.timeZoneId;
    if (date && calendarId && finalTimeZoneId) {
      const isISOFormat = moment(
        date,
        time.format.isoStringFormat,
        true
      ).isValid();
      if (isISOFormat) {
        date = moment(date);
      } else {
        date = moment.isMoment(date) ? date : moment(date, "DD-MM-YYYY");
      }
      const dateOnly = date?.format(time.format.dateOnly);
      const payload = {
        date: dateOnly,
        calendarId: calendarId?.toString(),
        timeZoneId: finalTimeZoneId,
      };
      try {
        let slots;
        if (typeof dataClient?.appointments?.getSlotsByDate === "function") {
          const res = await dataClient.appointments.getSlotsByDate({
            calendarId: calendarId.toString(),
            date: dateOnly,
            timeZoneId: finalTimeZoneId,
          });
          slots = res?.timeSlot?.items;
        } else {
          const res = await getSlotsByDate.executeQuery(payload);
          slots = res?.data?.timeSlot?.items;
        }
        return !!slots?.length;
      } catch (error) {
        console.error("checkAvailableSlots failed:", error);
        return false;
      }
    }
    return false;
  };
  const handleOnEventDrop = async (appoinment) => {
    // console.log("onSlotClick", slot);
    if (permission.edit) {
      const today = moment().startOf("day");
      if (moment(appoinment?.start).isBefore(today, "day")) {
        toast.warn("Appointment could not be scheduled for past dates");
        return;
      }
      setChecking(true);

      const isAvailable = await checkAvailabeSlots(appoinment);
      if (!isAvailable) {
        toast.warn(
          `No slots available for ${moment(appoinment?.start).format(time.format.date)}`
        );
        setChecking(false);
        return;
      }
      appoinment.startDate = moment(appoinment.start).format(
        time.format.isoStringFormat
      );
      appoinment.endDate = moment(appoinment.end).format(
        time.format.isoStringFormat
      );
      appoinment.isDragged = true;
      dispatch(setSelectedAppointmentToState(appoinment));
      setRequestType("reschedule");
      setOpenAppModal(true);
      setChecking(false);
    }
  };

  // const getCurrentTimezone = () => {
  //   const offset = moment().utcOffset();
  //   const hours = Math.floor(Math.abs(offset) / 60);
  //   const minutes = Math.abs(offset) % 60;
  //   const sign = offset >= 0 ? "+" : "-";
  //   const formattedOffset = `(UTC${sign}${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")})`;
  //   const currentTz = timezones.find((tz) =>
  //     tz.label.startsWith(formattedOffset)
  //   );
  //   return currentTz?.value;
  // };

  useEffect(() => {
    if (timezones.length) {
      const timezone = getCurrentTimezone(timezones);
      handleTimezoneChange("timeZoneId", timezone);
    }
  }, [timezones]);
  const [form, setForm] = useState({
    values: {
      timeZoneId: "",
    },
    touched: {
      timeZoneId: "",
    },
    errors: {
      timeZoneId: "",
    },
  });

  const handleTimezoneChange = (key, value) => {
    setForm((prev) => ({
      ...prev,
      values: {
        [key]: value,
      },
    }));
  };

  const ViewHeaderButtons = [
    // <Divider key={2} orientation="vertical" flexItem />,
    // <VideoPopper
    //   key={4}
    //   title={
    //     <UIButton
    //       id="tour-appointment-id-how"
    //       variant={"outlined"}
    //       key={6}
    //       title={
    //         <GetIcon
    //           sx={{ "& span": { fontSize: "0.9rem" } }}
    //           title={"How it works?"}
    //           icon={faCircleQuestion}
    //         />
    //       }
    //     />
    //   }
    //   tooltipText={"How it works?"}
    //   path="/assets/tour-videos/tour-appointment.mp4"
    //   caption={{
    //     title: "Schedule & Manage Appointments",
    //     description:
    //       "Schedule, track, and manage all your client interactions with smart Appointments feature.",
    //   }}
    // />,
    <TimeZoneField
      key="timezone-filter-field"
      onChange={handleTimezoneChange}
      form={form}
      sx={{ width: 150 }}
      dropdownWidth="300px"
    />,
    // Settings — disabled when user lacks scheduling edit permission
    <UIButton
      key={3}
      title={<GetIcon title="Settings" icon={faCalendarDays} />}
      onClick={goToSettings}
      variant={"outlined"}
      className="tour-appointment-settings-btn"
      disabled={!schedulingPermission.edit}
    />,
    <Divider key={4} orientation="vertical" flexItem />,
    <UIButton
      key={1}
      title={<GetIcon title="Add Appointment" icon={faPlus} />}
      onClick={() => {
        if (!permission.edit) return;
        trackingService.track(TRACKING_EVENTS.ADD_APPOINTMENT);
        dispatch(setSelectedAppointmentToState(null));
        setOpenAppModal(true);
        setRequestType("");
      }}
      variant={"contained"}
      className="tour-add-appointment-btn"
      disabled={!permission.edit}
    />,
  ].filter(Boolean);

  const latestAppointment = (event) => {
    if (!event) return event;
    const targets = [event.id, event.eventId]
      .filter((id) => id != null && id !== "")
      .map((id) => String(id));
    if (!targets.length) return event;
    const match = storedAppointments?.find((item) =>
      [item?.id, item?.eventId].some(
        (id) => id != null && targets.includes(String(id))
      )
    );
    return match ? { ...event, ...match } : event;
  };

  const handleSlotAction = (event, type, e) => {
    const resolved = latestAppointment(event);
    if (resolved) {
      dispatch(setSelectedAppointmentToState(resolved));
    }
    setRequestType(type);
    if (type == "view") {
      setOpenViewModal(true);
    } else {
      setOpenAppModal(true);
    }
  };
  const onDelete = (event) => {
    console.log("on delete", event);
    dispatch(setSelectedAppointmentToState(event));
    setOpenDeleteModal(true);
  };

  const eventActions = (row = {}) => {
    const editDisabled = !permission.edit;
    return [
      {
        name: "Edit",
        icon: faPenToSquare,
        callback: (e) => {
          if (editDisabled) return;
          console.log(row);
          handleSlotAction(e || row, "update");
          setOpenViewModal(false);
        },
        disabled: editDisabled,
      },
      {
        name: "Re-Schedule",
        callback: (e) => {
          if (editDisabled) return;
          handleSlotAction(e || row, "reschedule");
        },
        disabled: editDisabled,
      },
      {
        name: "Delete",
        icon: faTrashCan,
        callback: (e) => {
          if (editDisabled) return;
          console.log(row);
          onDelete(e || row);
          setOpenViewModal(false);
        },
        disabled: editDisabled,
      },
    ];
  };

  const handleAppointmentUpdate = async (selected, type) => {
    setRequestType("");
    if (type == "reschedule" || type == Enums.AppointmentStates.ReScheduled) {
      setOpenAppModal(true);
      setRequestType("reschedule");
    } else if (type == "update") {
      setOpenAppModal(true);
      setRequestType("update");
    } else {
      await handleAppointmentStatus(selected?.id, type);
      onCloseModal();
    }
  };

  const eventActionButtons = ({ value }) => {
    return <GridActionPopover options={eventActions(value)} />;
  };

  useEffect(() => {
    if (openCreateModal) {
      trackingService.track(TRACKING_EVENTS.ADD_APPOINTMENT);
      setOpenAppModal(true);
    }
  }, [openCreateModal]);

  // useEffect(() => {
  //   if (!openViewModal) {
  //     dispatch(setSelectedAppointmentToState(null));
  //   }
  // }, [openViewModal]);

  useEffect(() => {
    if (switchView == "columns") {
      if (switchType == "serviceTypes") {
        setColumnsData(
          serviceTypes
            .filter((st) => appointmentType.includes(st.calendarId))
            .map((r) => ({ ...r, resourceId: r.id, resourceTitle: r.name }))
        );
      } else {
        setColumnsData(
          members
            .filter((st) => appointmentType.includes(st.memberId))
            .map((r) => ({ ...r, resourceId: r.id, resourceTitle: r.name }))
        );
      }
    }
  }, [switchType, appointmentType, switchView, members, serviceTypes]);

  const handleRangeChange = (range) => {
    let rangeObj = { start: "", end: "" };
    switch (selectedView) {
      case "day":
      case "week": {
        rangeObj.start = range[0];
        rangeObj.end = range[range.length - 1];
      }
      case "month": {
        rangeObj = { ...range };
      }
    }
    // dispatch(setSelectedDateToState(rangeObj?.start));
  };

  const onNavigate = (a) => {
    dispatch(setSelectedDateToState(a));
    if (switchView != "list") {
    }
  };

  useEffect(() => {
    let range;
    if (selectedView === Views.DAY) {
      range = {
        start: moment(dayjs(calendarDate).toDate()),
        end: moment(dayjs(calendarDate).toDate()),
      };
    } else if (selectedView === Views.WEEK) {
      const getWeekDatesFromDate = () => {
        const start = moment(dayjs(calendarDate).toDate()).startOf("week");
        const end = moment(dayjs(calendarDate).toDate()).endOf("week");
        return { start, end };
      };
      range = getWeekDatesFromDate();
    } else if (selectedView === Views.MONTH) {
      range = {
        start: moment(dayjs(calendarDate).toDate()).startOf("month"),
        end: moment(dayjs(calendarDate).toDate()).endOf("month"),
      };
    }
    setRange(range);
  }, [calendarDate, selectedView]);

  // Extract primitive values to prevent object-reference based re-fetches
  const rangeStartStr = range?.start ? range.start.toISOString() : null;
  const rangeEndStr = range?.end ? range.end.toISOString() : null;

  useEffect(() => {
    if (switchView !== "list") {
      // Prevent early fetching before timezone is resolved, which causes duplicate calls
      if (timezones.length > 0 && !form.values.timeZoneId) return;

      const selectedTz = timezones.find(
        (tz) => tz.value === form.values.timeZoneId
      );

      // When switchView is 'columns', the effective view is a day view.
      // If we pass 'month' (the default selectedView), the backend will fetch a month's worth of data.
      const effectiveView = switchView === "columns" ? "day" : selectedView;

      let query = {
        ...makeRangeQuery(range, effectiveView),
        timeZoneId: selectedTz?.label || form.values.timeZoneId,
      };
      fetchAppointments(query);
    }
  }, [
    switchView,
    range,
    selectedView,
    form.values.timeZoneId,
    timezones.length,
  ]);

  useEffect(() => {
    if (returnFrom === "lead" && savedInfoWhenLeadCreate) {
      setOpenAppModal(true);
    } else if (pendingAppointmentModal && savedInfoWhenLeadCreate) {
      setOpenAppModal(true);
    }
  }, [returnFrom, pendingAppointmentModal, savedInfoWhenLeadCreate]);

  useEffect(() => {
    const eventId = router.query?.eventId;
    const openAt = router.query?.openAt;
    if (!eventId || !openAt) return;
    if (lastHandledOpenAtRef.current === openAt) return;

    const matchedAppointment = findAppointmentByEventId(appointments, eventId);
    if (!matchedAppointment) return;

    lastHandledOpenAtRef.current = openAt;
    dispatch(setSelectedAppointmentToState(matchedAppointment));
    setOpenViewModal(true);

    const nextQuery = { ...router.query };
    delete nextQuery.eventId;
    delete nextQuery.openAt;
    router.replace({ pathname: router.pathname, query: nextQuery }, undefined, {
      shallow: true,
    });
  }, [
    appointments,
    dispatch,
    router,
    router.query?.eventId,
    router.query?.openAt,
  ]);

  useEffect(() => {
    if (openAppModal && returnFrom === "lead") {
      router.replace("/crm/appointments", undefined, { shallow: true });
    }
  }, [openAppModal, returnFrom, router]);

  return (
    <>
      {!refetching && (
        <PageHeader
          title={"Appointments"}
          options={{}}
          buttons={ViewHeaderButtons}
        >
          <UIToggleButton
            selected={switchView}
            options={[
              {
                label: <GetFontAwesomeIcon icon={faCalendar} />,
                value: "calendar",
              },
              { label: <GetFontAwesomeIcon icon={faList} />, value: "list" },
              {
                label: <GetFontAwesomeIcon icon={faTableColumns} />,
                value: "columns",
              },
            ]}
            handleChange={(e, value) => handleViewChange(value)}
            name={"viewOptions"}
            sx={{
              ml: 2,
              "& .MuiButtonBase-root": {
                minWidth: "60px",
                height: "38px",
                fontWeight: "normal !important",
              },
            }}
          />
        </PageHeader>
      )}
      {refetching ? (
        <CircularLoader />
      ) : switchView === "calendar" ? (
        <CalendarSection
          className={selectedView != "month" ? "default-calendar" : ""}
          key={"calender-section"}
          eventActions={eventActions}
          appointments={
            appointmentType?.length ? appointments.filter((a) => !a.isBusy) : []
          }
          onSlotClick={onSlotClick}
          handleOnEventDrop={handleOnEventDrop}
          loading={checking}
          selectedView={selectedView}
          handleView={handleCalendarViewChange}
          handleRange={(rang) => {
            handleRangeChange(rang);
          }}
          step={30}
          timeslots={1}
          timeZone={form.values.timeZoneId}
          date={new Date(calendarDate)}
          onSelectEvent={(event, e) => {
            if (event.isBusy) return;
            handleSlotAction(event, "view", e);
          }}
          onNavigate={onNavigate}
          showContextMenu={true}
          grouping={true}
        />
      ) : switchView === "list" ? (
        <>
          {!isChanging && (
            <TableSection
              eventActions={eventActionButtons}
              appointments={
                appointmentType?.length
                  ? appointments.filter((a) => !a.isBusy)
                  : []
              }
              timeZone={form.values.timeZoneId}
            />
          )}
        </>
      ) : switchView == "columns" ? (
        <CalendarSection
          key={"calender-columns"}
          className={"calender-columns"}
          eventActions={eventActions}
          grouping={switchType == "serviceTypes" ? true : false}
          appointments={
            appointmentType?.length
              ? appointments.flatMap((a) => {
                  if (a.isBusy) {
                    if (switchType === "serviceTypes") {
                      // Find all calendars/serviceTypes that contain this member
                      const memberCalendars = serviceTypes.filter((s) =>
                        s.members?.some(
                          (m) =>
                            (m.id || m.participantId || m.memberId) ===
                              a.memberId ||
                            (m.id || m.participantId || m.memberId) ===
                              a.participantId
                        )
                      );
                      return memberCalendars.map((cal) => ({
                        ...a,
                        resourceId: cal.calendarId || cal.uuid || cal.id,
                      }));
                    } else {
                      return [
                        { ...a, resourceId: a.memberId || a.participantId },
                      ];
                    }
                  }
                  return [
                    {
                      ...a,
                      resourceId:
                        switchType == "serviceTypes"
                          ? a?.calendarId
                          : a?.memberId,
                    },
                  ];
                })
              : []
          }
          onSlotClick={onSlotClick}
          handleOnEventDrop={handleOnEventDrop}
          loading={checking}
          handleView={handleCalendarViewChange}
          handleRange={(rang) => {
            handleRangeChange(rang);
          }}
          timeZone={form.values.timeZoneId}
          resources={
            columnsData.length
              ? columnsData
              : [{ id: "__default__", title: "" }]
          }
          resourceIdAccessor="resourceId"
          resourceTitleAccessor="resourceTitle"
          // defaultView="customDay"
          selectedView={"day"}
          views={{
            day: true,
            // day: CustomDayView,
          }}
          customEventTile={DayEvent}
          eventStyling={DayEventStyling}
          step={30}
          timeslots={1}
          date={new Date(calendarDate)}
          onNavigate={onNavigate}
          // min={new Date(2025, 0, 1, 8, 0)} // start at 8:00 AM
          // max={new Date(2025, 0, 1, 20, 0)}
          onSelectEvent={(event, e) => {
            if (event.isBusy) return;
            handleSlotAction(event, "view");
          }}
          showContextMenu={true}
        />
      ) : null}

      <AppointmentModal
        size="sm"
        open={openAppModal}
        range={range}
        onClose={onCloseModal}
        onSave={onSaveAppointment}
        data={selectedAppointment}
        requestType={requestType}
        handleAppointmentStatus={handleAppointmentStatus}
        statusLoading={loading}
        returnFrom={returnFrom}
        isReturningFromLead={!!savedInfoWhenLeadCreate}
      />

      <ViewAppointment
        eventActions={eventActions}
        open={openViewModal}
        setOpen={(e) => {
          setOpenViewModal(false);
          setTimeout(() => {
            dispatch(setSelectedAppointmentToState(null));
          }, 500);
        }}
        appointment={selectedAppointment}
        handleAppointmentUpdate={handleAppointmentUpdate}
        btnLoading={loading}
        viewOnly={!permission.edit}
      />

      {/* delete modal */}
      <AppointmentDeleteModal
        open={openDeleteModal}
        onClose={onCloseModal}
        onDelete={onAppointmentDelete}
        loading={deleteLoading}
        selected={selectedAppointment}
      />
    </>
  );
};

export default DetailSection;
